import React from "react";
import ServiceSpace from "../../../components/dashboard/ServiceSpace";
import ErpAccessCard from "../../../components/dashboard/ErpAccessCard";
import pricing from "../../../assets/data/pricing.json";

function UserPlatformSale() {
  return (
    <ServiceSpace
      serviceCode="sales"
      flow="management"
      flowPath="/platform-gest"
      title="Relation client"
      lead="Le module de relation client de votre Gestion 360."
      offer="Suivi des clients, relances, pipeline commercial et activités dans un ERP en ligne."
      price={Math.min(
        pricing.platformSale.mensuel,
        pricing.platformSale.annuel,
      )}
      topContent={<ErpAccessCard />}
    />
  );
}

export default UserPlatformSale;
